@let compactView = view === rcFieldView.Small;
<div
  class="rc-field-action"
  [attr.dir]="readingDirection"
  [class.rc-field-action--readonly]="readonly"
  [class.rc-field-action--small]="compactView"
>
  <label
    class="rc-field-action__label"
    [class.rc-field-action__label--error]="error"
    [class.rc-field-action__label--active]="isActive()"
    [class.rc-field-action__label--disabled]="isDisabled"
    [class.rc-field-action__label--outline-label-top]="!!label || badge"
    [class.rc-field-action__label--with-prefix]="contentPrefix.children.length"
    [class.rc-field-action__label--with-suffix]="contentSuffix.children.length"
    [class.rc-field-action__label--readonly]="readonly"
  >
    <span #contentPrefix class="rc-field-action__prefix" [class.rc-field-action__prefix--disabled]="isDisabled">
      @if (!compactView) {
        <ng-content select="[prefix]"></ng-content>
      }
    </span>

    <span class="rc-field-action__input-container">
      <!-- Input -->
      <input
        #input
        class="rc-field-action__input"
        type="text"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        [class.rc-field-action__input--active]="isActive()"
        [class.rc-field-action__input--disabled]="isDisabled"
        [class.rc-field-action__input--error]="error"
        [min]="min"
        [max]="max"
        [step]="step"
        [required]="required"
        [attr.tabindex]="accessible ? 0 : -1"
        [attr.aria-hidden]="!accessible"
        [ngModel]="displayValue"
        (ngModelChange)="updateValue($event)"
        [disabled]="isDisabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        (focus)="onFocus($event)"
        (blur)="[onTouched(), onBlur($event)]"
      />
    </span>

    <span #contentSuffix class="rc-field-action__suffix" [class.rc-field-action__suffix--disabled]="isDisabled">
      @if (!compactView) {
        <ng-content select="[suffix]"></ng-content>
      }
    </span>
  </label>

  @if (!readonly) {
    <div class="rc-field-action__actions">
      @if (isLoading) {
        <div class="loader">
          <app-loader [withinContent]="true" [transparent]="true" [size]="rcLoaderSize"></app-loader>
        </div>
      } @else {
        <rc-button
          data-qa="vs-prices-page-product-price-button-close"
          variant="tertiary"
          size="medium"
          type="button"
          iconname="feedback-failure-alt"
          rounded="true"
          [disabled]="isDisabled"
          (click)="onEdit(false, isDisabled)"
        ></rc-button>
        @if (value || value === 0) {
          <rc-button
            data-qa="vs-prices-page-product-price-button-save"
            variant="quaternary"
            size="medium"
            type="button"
            iconname="feedback-success"
            rounded="true"
            [disabled]="isDisabled"
            (click)="onSubmit()"
          ></rc-button>
        }
      }
    </div>
  } @else {
    <div class="rc-field-action__actions readonly">
      @if (compactView) {
        <rc-link
          data-qa="vs-prices-page-product-price-button-edit"
          variant="primary"
          size="medium"
          [disabled]="isDisabled"
          (click)="onEdit(true, isDisabled)"
        >
          {{ 'action_edit' | translateKey }}
        </rc-link>
      } @else {
        <rc-link
          data-qa="vs-prices-page-product-price-button-edit"
          variant="secondary"
          size="extra-large"
          iconname="edit"
          [disabled]="isDisabled"
          (click)="onEdit(true, isDisabled)"
        ></rc-link>
      }
    </div>
  }

  <!-- Error message -->
  @if (error || customErrorTemplate) {
    <div class="rc-field-action__error">
      @if (error) {
        <ng-container>{{ error }}</ng-container>
      }
      @if (customErrorTemplate) {
        <ng-container [ngTemplateOutlet]="customErrorTemplate"></ng-container>
      }
    </div>
  }

  <!-- Hint -->
  @if (hint) {
    <div class="rc-field-action__hint">{{ hint }}</div>
  }
</div>
